import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './Home.css';

const Home = () => {
  const { getFeaturedProjects, services, loading } = useData();
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [displayServices, setDisplayServices] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Function to get SVG icon based on service index
  const getServiceIcon = (index) => {
    const icons = [
      // Icon 1: Home/Building (Proiectare Arhitecturală)
      <svg key="icon-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>,
      // Icon 2: Design/Complex Services (Servicii Complexe)
      <svg key="icon-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" fill="currentColor">
        <path d="M1024.022 99.36c-19.324-.017-38.646 7.15-52.98 21.55L120.937 971.023c-28.67 28.668-28.537 77.295.132 105.963l849.971 849.965c28.67 28.678 77.294 28.804 105.963 0l850.106-850.1c28.669-28.667 28.536-77.296-.135-105.964L1077.002 120.91c-14.334-14.334-33.657-21.534-52.98-21.55zm-.065 126.045l798.66 798.666l-798.66 798.657l-798.66-798.657l798.66-798.666zm-18.879 392.361l-.002.416c0 .01-8.367 1.55-8.37 1.55c-.01 0-6.853 4.644-6.858 4.644c-.01 0-4.764 7.062-4.768 7.062c0 .01-1.61 8.418-1.613 8.418V926.1l-202.64-202.64h.01c-.01 0-7.197-4.644-7.2-4.644c-.012 0-8.017-1.627-8.078-1.638c-.078.012-8.315 1.543-8.319 1.543c-.01-.01-7.065 4.74-7.068 4.74l-26.633 26.617l-4.861 7.16c-.01 0-1.504 8.223-1.504 8.223c0 .01 1.614 8.127 1.615 8.127c0 .01 4.613 7.16 4.615 7.16l202.54 202.543H639.486l-.056-.068c0 .01-8.332 1.837-8.336 1.837c-.01.01-6.851 4.645-6.856 4.645v-.049c-.01.01-4.763 7.065-4.767 7.065c-.01 0-1.612 8.416-1.615 8.416v37.666s1.6 8.515 1.658 8.515c0 .02 4.745 6.87 4.746 6.87c.01 0 6.894 4.644 6.896 4.644c.01.02 8.368 1.838 8.371 1.838h286.36L723.52 1267.036v-.076c-.01.01-4.86 7.16-4.862 7.16c-.01.01-1.506 8.223-1.506 8.223c0 .019 1.617 8.127 1.618 8.127c0 0 4.63 7.16 4.615 7.16l26.637 26.617c.01.01 7.278 4.74 7.28 4.74l8.108 1.645c.012 0 8.213-1.547 8.217-1.547c0 0 7.171-4.838 7.174-4.838l202.668-202.668v286.861l-.053-.056c0 .01 1.66 8.513 1.658 8.513c0 .01 4.745 6.87 4.745 6.87c.01.01 6.894 4.644 6.896 4.644c0 0 8.309 1.741 8.371 1.838l37.654-.01c.01 0 8.532-1.74 8.537-1.74c0 0 6.851-4.645 6.856-4.645c.01-.01 4.741-6.869 4.746-6.869c0 0 1.633-8.515 1.637-8.515v-286.698l202.523 202.514c-.01.02 7.276 4.74 7.28 4.74c.01.01 8.106 1.55 8.109 1.55c.012 0 8.212-1.55 8.217-1.55c0 0 7.17-4.838 7.176-4.838l26.625-26.634c.01 0 4.719-7.065 4.779-7.065c0-.02 1.64-8.32 1.6-8.416c0-.01-1.618-8.129-1.62-8.129c-.012.01-4.713-7.256-4.775-7.256l-202.016-202.029h285.957c.01.01 8.532-1.742 8.535-1.742c.01 0 6.853-4.645 6.856-4.645c.01-.019 4.74-6.869 4.746-6.869c0 0 1.633-8.513 1.637-8.513v-37.657c0-.01-1.626-8.32-1.623-8.418c-.01-.01-4.722-7.062-4.78-7.062c-.01-.01-6.895-4.645-6.898-4.645c0 .01-8.508-1.837-8.512-1.74h-286.824l202.926-202.92c.01-.01 4.717-7.064 4.777-7.064c0-.02 1.643-8.32 1.643-8.32c0-.01-1.616-8.128-1.617-8.128c-.01-.01-4.846-7.16-4.848-7.16l-26.631-26.636c-.01 0-7.042-4.74-7.045-4.74c-.01-.01-8.106-1.548-8.111-1.548c-.012 0-8.347 1.547-8.35 1.547c-.01.01-7.066 4.74-7.068 4.74l-202.672 202.67V639.546c0-.01-1.626-8.321-1.623-8.418c-.01-.02-4.72-7.063-4.72-7.063c-.01-.01-6.895-4.644-6.897-4.644c-.01 0-8.532-1.645-8.534-1.645l-37.66-.01zm-239.52 99.41l.034-.005h-.063l.03.006z"/>
      </svg>,
      // Icon 3: Sun/Energy (Eficiență Energetică)
      <svg key="icon-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor">
        <path d="M 24.984375 3.9863281 A 1.0001 1.0001 0 0 0 24 5 L 24 11 A 1.0001 1.0001 0 1 0 26 11 L 26 5 A 1.0001 1.0001 0 0 0 24.984375 3.9863281 z M 10.888672 9.890625 A 1.0001 1.0001 0 0 0 10.193359 11.607422 L 14.392578 15.806641 A 1.0001 1.0001 0 1 0 15.806641 14.392578 L 11.607422 10.193359 A 1.0001 1.0001 0 0 0 10.888672 9.890625 z M 39.080078 9.890625 A 1.0001 1.0001 0 0 0 38.392578 10.193359 L 34.193359 14.392578 A 1.0001 1.0001 0 1 0 35.607422 15.806641 L 39.806641 11.607422 A 1.0001 1.0001 0 0 0 39.080078 9.890625 z M 25 15 A 1.0001 1.0001 0 0 0 24.591797 15.082031 C 19.260044 15.307579 15 19.611572 15 25 C 15 30.533333 19.466667 35 25 35 C 30.533333 35 35 30.533333 35 25 C 35 19.612238 30.740979 15.308576 25.410156 15.082031 A 1.0001 1.0001 0 0 0 25 15 z M 5 24 A 1.0001 1.0001 0 1 0 5 26 L 11 26 A 1.0001 1.0001 0 1 0 11 24 L 5 24 z M 39 24 A 1.0001 1.0001 0 1 0 39 26 L 45 26 A 1.0001 1.0001 0 1 0 45 24 L 39 24 z M 15.080078 33.890625 A 1.0001 1.0001 0 0 0 14.392578 34.193359 L 10.193359 38.392578 A 1.0001 1.0001 0 1 0 11.607422 39.806641 L 15.806641 35.607422 A 1.0001 1.0001 0 0 0 15.080078 33.890625 z M 34.888672 33.890625 A 1.0001 1.0001 0 0 0 34.193359 35.607422 L 38.392578 39.806641 A 1.0001 1.0001 0 1 0 39.806641 38.392578 L 35.607422 34.193359 A 1.0001 1.0001 0 0 0 34.888672 33.890625 z M 24.984375 37.986328 A 1.0001 1.0001 0 0 0 24 39 L 24 45 A 1.0001 1.0001 0 1 0 26 45 L 26 39 A 1.0001 1.0001 0 0 0 24.984375 37.986328 z"></path>
      </svg>,
      // Icon 4: Tools/Settings
      <svg key="icon-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M12 1v6m0 6v6m5.5-14.5l-4.2 4.2m-6.6 6.6l-4.2 4.2m14.5-.5l-4.2-4.2m-6.6-6.6l-4.2-4.2"></path>
      </svg>,
      // Icon 5: Layers/Stack
      <svg key="icon-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
        <polyline points="2 17 12 22 22 17"></polyline>
        <polyline points="2 12 12 17 22 12"></polyline>
      </svg>,
      // Icon 6: Compass/Navigation
      <svg key="icon-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"></circle>
        <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>
      </svg>
    ];
    return icons[index % icons.length];
  };

  useEffect(() => {
    if (!loading) {
      setFeaturedProjects(getFeaturedProjects().slice(0, 6));
      setDisplayServices(services.slice(0, 3));
    }
  }, [loading, getFeaturedProjects, services]);

  useEffect(() => {
    if (loading) {
      return;
    }

    const targetId = (location.hash ? location.hash.replace('#', '') : null) || location.state?.scrollTo;
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      if (location.state?.scrollTo) {
        navigate(location.pathname + (location.hash || ''), { replace: true, state: {} });
      }
    }
  }, [loading, location, navigate]);

  if (loading) {
    return <Loading />;
  }

  const servicesToDisplay = displayServices.length > 0 ? displayServices : services.slice(0, 3);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-logo">
            <span className="hero-eka">EKA</span>
            <span className="hero-company">COMPANY</span>
          </div>
          <p className="hero-subtitle">
            Alege dintre proiectele noastre atractive, practice și durabile, cu construcție economică,
            eficiență energetică, estetică și un confort excepțional în locuirea de zi cu zi.
          </p>
          <div className="hero-buttons">
            <Link to="/projects" className="btn">Vezi Toate Proiectele</Link>
            <Link to="/contact" className="btn btn-secondary">Contactează-ne</Link>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="despre-noi">
        <div className="container">
          <div className="about-card">
            <div className="about-header">
              <h2>Despre Noi</h2>
              <p className="about-subtitle">Partenerul tău complet pentru proiectare și consultanță tehnică</p>
            </div>
            <div className="about-content">
              <div className="about-layout">
                <div className="about-text">
                  <p>
                    EKA COMPANY este o echipă de specialiști care oferă servicii complete de proiectare și consultanță tehnică în sectorul civil.
                    Suntem capabili să răspundem unei game variate de nevoi în domeniul instalațiilor pentru construcții, precum:
                  </p>
                  <p>
                    Suntem o echipă tânără, dinamică și pasionată, dedicată nevoilor clienților noștri și pregătită să facă față rigorilor tehnice și legislative care definesc piața construcțiilor din România.
                  </p>
                  <p>
                    De-a lungul timpului, am acumulat experiență solidă într-un domeniu aflat într-o continuă transformare și reglementare. Specialiștii noștri sunt permanent conectați la inovațiile și standardele internaționale din domeniul instalațiilor,
                    integrând în proiectele noastre cele mai noi și eficiente soluții tehnice.
                  </p>
                  <p>
                    Firma elaborează proiecte începând de la faza de autorizare a construcției, până la studii privind utilizarea unor sisteme alternative de eficiență ridicată, analizate din punct de vedere tehnic, economic și ecologic.
                  </p>
                  <p>
                    Oferim consultanță tehnică pe tot parcursul derulării proiectului și recomandăm cele mai potrivite sisteme de instalații pentru fiecare beneficiar.
                  </p>
                </div>
                <aside className="about-side">
                  <div className="about-highlight">
                    <h3>Servicii specializate</h3>
                    <ul className="about-services">
                      <li>
                        <span className="about-icon">⚡</span>
                        <span>proiectare instalații electrice</span>
                      </li>
                      <li>
                        <span className="about-icon">💧</span>
                        <span>proiectare instalații sanitare</span>
                      </li>
                      <li>
                        <span className="about-icon">🔥</span>
                        <span>proiectare instalații termice.</span>
                      </li>
                    </ul>
                  </div>
                  <div className="about-highlight about-highlight--secondary">
                    <h3>Parteneriate extinse</h3>
                    <p>
                      Ne desfășurăm activitatea în județul Constanța și, în funcție de disponibilitate și de tipul proiectului, în alte zone ale țării.
                      Succesul nostru se bazează și pe ecosistemul solid de colaboratori pe care l-am construit în timp. Prin parteneriatele dezvoltate, putem oferi soluții complete pentru clădiri rezidențiale, comerciale sau industriale
                      de la arhitectură, proiectare și execuția instalațiilor, până la întocmirea documentației necesare pentru obținerea autorizărilor și avizelor de funcționare de la instituțiile abilitate.
                    </p>
                  </div>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Proiecte Recomandate</h2>
          <p className="section-subtitle">Descoperă cele mai populare și recomandate designuri ale noastre</p>
          
          {featuredProjects.length > 0 ? (
            <div className="grid grid-3">
              {featuredProjects.map(project => (
                <Link to={`/projects/${project.slug}`} key={project.id} className="project-card card">
                  {project.featured_image && (
                    <img src={project.featured_image} alt={project.title} />
                  )}
                  <div className="card-content">
                    <h3>{project.title}</h3>
                    <p className="category">{project.category_name}</p>
                    {project.size && <p className="size">Dimensiune: {project.size}</p>}
                    {project.show_price && project.price && (
                      <div className="price-section">
                        {project.discount_percentage && (
                          <span className="discount">-{project.discount_percentage}%</span>
                        )}
                        <div>
                          {project.original_price && (
                            <span className="original-price">{project.original_price} lei</span>
                          )}
                          <span className="price">{project.price} lei</span>
                        </div>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="no-data">Nu există proiecte recomandate disponibile încă.</p>
          )}

          <div className="text-center">
            <Link to="/projects" className="btn">Vezi Toate Proiectele</Link>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="section services-overview">
        <div className="container">
          <h2 className="section-title">Serviciile Noastre</h2>
          <p className="section-subtitle">Soluții profesionale pentru toate nevoile tale de design și inginerie</p>
          
          {servicesToDisplay.length > 0 ? (
            <div className="grid grid-3">
              {servicesToDisplay.map((service) => (
                <div key={service.id} className="service-card card">
                  <div className="card-content">
                    <h3>
                      <div className="service-icon-inline">
                        {getServiceIcon(service.icon)}
                      </div>
                      {service.title}
                    </h3>
                    <p>{service.short_description}</p>
                    <Link to="/services" className="btn">Află Mai Mult</Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-data">Informații despre servicii în curând.</p>
          )}
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <h2>Vrei un design care să te reprezinte?</h2>
          <p>Suntem aici pentru TINE! Hai să creăm împreună proiectul tău de vis.</p>
          <Link to="/contact" className="btn">Contactează-ne</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;

